import React, { useEffect } from "react";
import "./App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import BackToTopButton from "./components/BackToTopButton";
import Home from "./pages/Home";
import ChiSiamo from "./pages/ChiSiamo";
import Servizi from "./pages/Servizi";
import Progetti from "./pages/Progetti";
import FAQ from "./pages/FAQ";
import Contatti from "./pages/Contatti";
import News from "./pages/News";
import NewsDetail from "./pages/NewsDetail";
import Admin from "./pages/Admin";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TerminiCondizioni from "./pages/TerminiCondizioni";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

// Redirect /news/:id -> /blog/:id preservando il param dinamico
const NewsRedirect = () => {
  const { pathname } = useLocation();
  return <Navigate to={pathname.replace(/^\/news/, "/blog")} replace />;
};

const Layout = () => (
  <div className="min-h-screen flex flex-col bg-white">
    <ScrollToTop />
    <Header />
    <main className="flex-1">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/chi-siamo" element={<ChiSiamo />} />
        <Route path="/servizi" element={<Servizi />} />
        <Route path="/progetti" element={<Progetti />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contatti" element={<Contatti />} />
        <Route path="/blog" element={<News />} />
        <Route path="/blog/:id" element={<NewsDetail />} />
        {/* Retrocompatibilita': redirect dei vecchi URL /news -> /blog */}
        <Route path="/news" element={<Navigate to="/blog" replace />} />
        <Route path="/news/:id" element={<NewsRedirect />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/termini-e-condizioni" element={<TerminiCondizioni />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </main>
    <Footer />
    <WhatsAppButton />
    <BackToTopButton />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout />
      </BrowserRouter>
    </div>
  );
}

export default App;
